exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Permissions-Link {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.GlobalMenuGroup-Permissions-Container {\n  border-bottom: 1px solid lightgrey;\n}\n.Brand-Not-Selected-Error {\n  padding: 0 !important;\n}\n.Brand-Not-Selected-Error > .v-input__control > .v-input__slot {\n  display: none !important;\n}\n", ""]);

